export default "__VITE_ASSET__4bc44de1__"